<script setup>
import { storeToRefs } from 'pinia';
import { useUserStore } from '../../../user/stores/user-store';
import ProfileNavComponent from '../components/ProfileNavComponent.vue';
import { RouterView } from 'vue-router';

/**
 * User store
 */
const { user } = storeToRefs(useUserStore());
</script>

<template>
  <div class="container">
    <div class="row my-3 align-items-center" v-if="user">
      <div class="col-auto">
        <img
          src="../../../app/assets/logo.png"
          class="rounded-circle"
          alt="Profile"
        />
      </div>
      <div class="col">
        <div>
          <span class="fs-2" v-if="user">{{ user.fullName }}</span>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-3">
        <ProfileNavComponent />
      </div>
      <div class="col-lg-9 mt-3 mt-lg-0">
        <div class="card mb-3">
          <div class="card-body">
            <RouterView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
